import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function calculateDeliveryDate({ clinicId, appointmentDate }) {
  const axios = axiosInstance().primoLab;
  const { data } = await axios.post('/clinic-deliveries/calculate-delivery-date', {
    clinic_id: clinicId,
    appointment_date: appointmentDate,
  });
  return data;
} 